import React from 'react'
import { ArticleHeading, Section, Dl, Dt, ArticleHeadingH4, ArticleHeadingH3 } from '../content'
import { md } from '../../lib/remarkable'
import Img from '@bootstrap-styled/v4/lib/Img'
import BlockText from '../content/BlockText'
import { sortBy } from 'lodash'

const addonFields = [
  // 'Q&A with [first name]',
  'What made you decide to become a physiotherapist?',
  'What do you love most about your job?',
  'Why should a new patient decide to choose you?',
  'What do you enjoy doing when you\'re not working?',
  'What do you enjoy about {suburb} and the community?',
]

function BlockPhysios ({ title, practitioners, image, suburbName }) {
  const content = React.useMemo(() => practitioners.map(p => {
    const html = p.profile && <div>{md.render(p.profile)}</div>
    let hasAdditionalContent = false
    const additionalContent = p.additionalContent ? sortBy(Object.keys(p.additionalContent), (k, index) => {
      const i = addonFields.indexOf(k)
      if (i !== -1) return i
      else return 100+index
    }).map(k => {
      if (!p.additionalContent[k]) return null
      hasAdditionalContent = true
      let title = k.replace('{suburb}', suburbName)

      return <BlockText
        title={title}
        value={p.additionalContent[k]}
        titleLevel={5}
        contentLevel={'article'}
      />
    }).filter(v => !!v) : []

    return {
      ...p,
      html,
      additionalContent,
      hasAdditionalContent,
    }
  }), [practitioners])

  return (
    <Section>
      { title && <ArticleHeading>{title}</ArticleHeading> }
      { image && <Img className={'mb-3'} fluid src={image}/> }
      { content.map((p, i) => (
        <div className={'mb-3'} key={`clinic-practitioners-${i}`}>
          <ArticleHeadingH3>{p.name}</ArticleHeadingH3>
          {p.html}
          <Dl className={'row'}>
            { p.AHPRA && <React.Fragment>
              <Dt className={'col-4'}>AHPRA registration</Dt>
              <Dl className={'col-8'}>{p.AHPRA}</Dl>
            </React.Fragment>}
            { (p.education && p.education.place) && <React.Fragment>
              <Dt className={'col-4'}>Education</Dt>
              <Dl className={'col-8'}>{p.education.place} {p.education.graduation && `(${p.education.graduation})`}</Dl>
            </React.Fragment>}
          </Dl>
          {p.hasAdditionalContent && <ArticleHeadingH4>Q&A with {p.name}</ArticleHeadingH4>}
          {p.additionalContent}
        </div>
      ))}
    </Section>
  )
}

export default BlockPhysios
